import { useEffect, useMemo, useState } from 'react';
import httpService from '../../../core/services/HttpService';
import './qualification-pills.css';

type Qualification = { id: number; name: string; category: string };

export function QualificationPills({
  selectedIds,
  onChange,
}: {
  selectedIds: number[];
  onChange: (ids: number[]) => void;
}) {
  const [all, setAll] = useState<Qualification[]>([]);
  const selected = useMemo(() => new Set<number>(selectedIds), [selectedIds]);

  useEffect(() => {
    let alive = true;
    httpService.get<Qualification[]>('/api/admin/qualifications/').then((res) => {
      if (!alive) return;
      setAll(res.data ?? []);
    });
    return () => { alive = false; };
  }, []);

  function toggle(id: number) {
    const next = new Set(selected);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    onChange(Array.from(next));
  }

  const grouped = useMemo(() => {
    const map = new Map<string, Qualification[]>();
    for (const q of all) {
      const cat = q.category || 'Sonstige';
      if (!map.has(cat)) map.set(cat, []);
      map.get(cat)!.push(q);
    }
    return Array.from(map.entries()).sort(([a], [b]) => a.localeCompare(b, 'de'));
  }, [all]);

  if (all.length === 0) return null;

  return (
    <div className="qual-pills-section">
      {grouped.map(([category, quals]) => (
        <div key={category} className="qual-category">
          <span className="qual-category-label">{category}</span>
          <div className="qual-pills-wrap">
            {quals.map((q) => {
              const isOn = selected.has(q.id);
              return (
                <button
                  key={q.id}
                  type="button"
                  aria-pressed={isOn}
                  className={`qual-pill ${isOn ? 'on' : 'off'}`}
                  onClick={() => toggle(q.id)}
                >
                  {q.name}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
